import DetalleOrdenCompra from "./DetalleOrdenCompraContainer";
export default DetalleOrdenCompra;